import { attachComponent } from 'awr-domain'

import { finalizeActionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain'

import { getShopifyCartUrl } from '../shopify/shopify-ajax-client.js'

export const finalizeActionComponents = [
  attachComponent
    .withEntity('Deck')
    .withComponent(finalizeActionComponent, 'primary')
    .attach(
      memoEval(
        () => [],
        () => ({
          variant: getShopifyCartUrl() ? 'primary' : 'secondary',
          title: '',
          label: 'Add to Cart',
          icon: 'ShoppingCartSimple',
          handler: 'addToCart',
        })
      )
    ),

  attachComponent
    .withEntity('Deck')
    .withComponent(finalizeActionComponent, 'secondary')
    .attach(
      memoEval(
        () => [],
        () => ({
          variant: getShopifyCartUrl() ? 'secondary' : 'primary',
          label: 'Get Full Details',
          title: 'Get a detailed summary by email',
          icon: 'PaperPlaneTilt',
          handler: 'getDetailsByEmail',
        })
      )
    ),
]
